<template>
    <router-link
        v-bind:to="'/' + game"  
        class="home-featured-link" 
        v-bind:class="'link-' + game"
        v-bind:style="{ 'height': homeHeight + 'px' }"
    >
        <div class="link-featured">FEATURED</div>
    </router-link>
</template>


<script>
    export default {
        name: 'HomeFeaturedLink',
        props: [
            'game'
        ],
        data() {
            return {
                homeHeight: 170
            }
        },
        methods: {
            homeSetHeight() {
                this.homeHeight = Number(this.$refs.featuredLink.$el.getBoundingClientRect().width * (this.game === 'battles' ? 0.591 : 0.574324)).toFixed(4);
            }
        },
        mounted() {
            window.addEventListener('resize', this.homeSetHeight);
            this.homeSetHeight();
        },
        destroyed() { 
            window.removeEventListener('resize', this.homeSetHeight); 
        }
    }
</script>


<style scoped>
    a.home-featured-link {
        width: calc(25% - 24px);
        position: relative;
        margin-right: 32px;
        padding: 1px;
        font-family: 'Rubik';
        transition: transform 0.3s ease;
    }

    a.home-featured-link:hover {
    transform: scale(1.05) rotate(1deg); /* Slight rotation adds dynamism */
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3); /* Adds a shadow for depth */
    filter: brightness(1.2); /* Makes the image slightly brighter */
}

a.home-featured-link:hover .link-featured {
    background: linear-gradient(255deg, #00ff2a 0%, #00ff37 100%);
    transition: background 0.3s ease, transform 0.3s ease;
    transform: translate(-50%, 5px); /* Small lift effect */
}

    a.home-featured-link.link-battles {
        background: url('~@/assets/img/games/battles.webp');
        background-repeat: no-repeat;
        background-size: 100% auto;
    }

    a.home-featured-link.link-crash {
        background: url('~@/assets/img/games/crash.webp');
        background-repeat: no-repeat;
        background-size: 100% auto;
    }

    a.home-featured-link.link-spin {
        background: url('~@/assets/img/games/spin.webp');
        background-repeat: no-repeat;
        background-size: 100% auto;
    }

    a.home-featured-link.link-blackjack {
        background: url('~@/assets/img/games/blackjack.webp');
        background-repeat: no-repeat;
        background-size: 100% auto;
    }

    a.home-featured-link.link-duels {
        background: url('~@/assets/img/games/duels.webp');
        background-repeat: no-repeat;
        background-size: 100% auto;
    }

    a.home-featured-link:last-of-type {
        margin-right: 0;
    }

    a.home-featured-link .link-featured {
        width: 65px;
        height: 21px;
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        bottom: -9px;
        left: 50%;
        transform: translate(-50%, 0);
        font-size: 10px;
        font-weight: 800;
        color: #ffffff;
        background: linear-gradient(255deg, #00b7ff 0%, #00b7ff 100%);
        clip-path: polygon(4px 0, calc(100% - 4px) 0, 100% 25%, 100% 75%, calc(100% - 4px) 100%, 4px 100%, 0 75%, 0 25%);
    }

    @media only screen and (max-width: 1050px) {
        a.home-featured-link {
            width: calc(25% - 9px);
            margin-right: 12px;
        }

        a.home-featured-link:last-of-type {
            margin-right: 0;
        }
    }

    @media only screen and (max-width: 800px) {
        a.home-featured-link {
            width: calc(50% - 9px);
            margin-top: 20px;
        }

        a.home-featured-link:nth-child(2n) {
            margin-right: 0;
        }

        a.home-featured-link:nth-of-type(1),
        a.home-featured-link:nth-of-type(2) {
            margin-top: 0;
        }
    }

    @media only screen and (max-width: 450px) {
        a.home-featured-link .link-featured {
            display: none;
        }
    }
</style>
